import { all, call, put, takeLatest, takeEvery } from 'redux-saga/effects'
// import * as Sentry from '@sentry/node'
import {
  FETCH_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFICATION,
  setUpgradeCreditsForProductSpecification,
  fetchUpgradeCreditsForProductSpecification,
} from '../../actions/entitlement/entitlement'
import { SET } from '../../actions/jobs/jobs'
import fetchUpgradeEntitlements from '../../../service/entitlement/fetch-upgrade-entitlements/fetchUpgradeEntitlements'
import { getProductDefinitionId } from '../../../util/get-definition/getDefinition'

import type {
  FetchUpgradeCreditsForProductSpecificationAction
} from '../../actions/entitlement/entitlement'
import type { SetJobsAction } from '../../actions/jobs/jobs'
import type { JobPostingUpgradeEntitlement } from '../../reducers/entitlement/entitlement'

export function* fetchUpgradeCreditsForJobsSaga(
  action: SetJobsAction
) {
  let jobs = []

  if (action.type === SET) {
    jobs = action.payload.jobs
  }

  const distinctProductSpecifications = new Map()

  jobs
    .filter(({ product }) => product)
    .forEach(({ product }) => {
      const key: string = getProductDefinitionId(product)

      if (!distinctProductSpecifications.has(key)) {
        distinctProductSpecifications.set(key, product)
      }
    })

  const values = Array.from(distinctProductSpecifications.values()).filter(Boolean)

  if (values.length > 0) {
    yield all(
      values.map(productSpecification =>
        put(fetchUpgradeCreditsForProductSpecification(productSpecification))
      ),
    )
  }
}

export function* fetchUpgradeCreditsForProductSpecificationSaga(
  action: FetchUpgradeCreditsForProductSpecificationAction,
) {
  try {
    const fetchedEntitlements: Array<JobPostingUpgradeEntitlement> = yield call(
      fetchUpgradeEntitlements,
      action.payload
    )

    yield put(setUpgradeCreditsForProductSpecification(action.payload, fetchedEntitlements))
  } catch (e) {
    // yield call(Sentry.captureException, e)
  }
}

export default function* saga() {
  yield all([
    takeLatest(SET, fetchUpgradeCreditsForJobsSaga),
    takeEvery(
      FETCH_UPGRADE_CREDITS_FOR_PRODUCT_SPECIFICATION,
      fetchUpgradeCreditsForProductSpecificationSaga,
    ),
  ])
}
